export default from './CookiesPolicy';



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web/CookiesPolicy/index.js